import { put, call } from 'redux-saga/effects'
//import { isMobile } from 'react-device-detect'
import { INIT_KEYCLOAK, SET_LANGUAGE, SET_MESSAGE } from '../actions/type'
import i18n from '../../i18n'
import q from "query-string"
import { getHttpClient, apiHelper, setLanguageConference } from '../../helpers'
import { isEmpty } from 'lodash'

function* setLocale() {
    const queryLng = q.parse(window.location.search).language
    let lng = "th"
    if(queryLng) {
        lng = queryLng === 'zhCN' ? 'cn' : queryLng
    } else {
        lng = localStorage.getItem('language') === "zhCN" ? 'cn' : localStorage.getItem('language')
    }

    i18n.changeLanguage(lng)
    setLanguageConference(lng)

    yield put({
        type: SET_LANGUAGE,
        payload: !isEmpty(lng) ? lng : 'th'
    })
}

function* setMessageNoti() {
    try {
        const data = yield call(getHttpClient, {}, `${window._env_.utilityUrl}/${apiHelper.getMessageNoti()}`)
        yield put({
            type: SET_MESSAGE,
            payload: data
        })
    } catch (err) {
        console.error(err);
    }
}

function* startup() {
    // if (!isMobile) {
    //     yield put({ type: INIT_KEYCLOAK })
    // }
    yield put({ type: INIT_KEYCLOAK })
    yield call(setLocale)
    yield call(setMessageNoti)
}

export default startup